module.exports = __webpack_public_path__ + "img/47.b4ac667a.gif";